export default {
  setDeployments: 'setDeployments',
};
